import React from 'react'
export function normalizeNames(name) {
  const charactersMap = {
    Ü: 'UE',
    Ä: 'AE',
    Ö: 'OE',
    ü: 'ue',
    ä: 'ae',
    ö: 'oe',
    ß: 'ss',
    ẞ: 'ss',
  }

  return name
    .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, a => {
      const big = charactersMap[a.slice(0, 1)]
      return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1)
    })
    .replace(new RegExp('[' + Object.keys(charactersMap).join('|') + ']', 'g'), a => charactersMap[a])
}

export const useMediaQuery = width => {
  const [targetReached, setTargetReached] = React.useState(false)

  const updateTarget = React.useCallback(e => {
    if (e.matches) {
      setTargetReached(true)
    } else {
      setTargetReached(false)
    }
  }, [])
  React.useEffect(() => {
    let media = window.matchMedia(`(min-width: ${width}px)`)

    if (typeof width === 'string') {
      media = window.matchMedia(width)
    }

    media.addListener(updateTarget)

    // Check on mount (callback is not called until a change occurs)
    if (media.matches) {
      setTargetReached(true)
    }

    return () => media.removeListener(updateTarget)
  }, [updateTarget, width])

  return targetReached
}

export const gnztColors = ['#ea7695', '#B37ACC', '#00be97']

export const randomGnztColor = () => {
  return gnztColors[Math.floor(Math.random() * gnztColors.length)]
}
